// How It Works page data and content

// Restaurant onboarding steps
export const restaurantSteps = [
  {
    step: 1,
    title: 'Sign Up & Onboard',
    description: 'Create your restaurant profile and complete the onboarding process in minutes.',
    icon: 'mdi:account-plus',
  },
  {
    step: 2,
    title: 'Browse Suppliers',
    description: 'Explore our network of verified suppliers and discover new products.',
    icon: 'mdi:store-search',
  },
  {
    step: 3,
    title: 'Place Orders',
    description: 'Order from multiple suppliers in one place with our streamlined ordering system.',
    icon: 'mdi:cart-plus',
  },
  {
    step: 4,
    title: 'Track & Manage',
    description: 'Monitor order status, manage inventory, and track deliveries in real-time.',
    icon: 'mdi:chart-line',
  },
];

// Supplier onboarding steps
export const supplierSteps = [
  {
    step: 1,
    title: 'Join Our Network',
    description: 'Apply to become a verified supplier and get listed on our platform.',
    icon: 'mdi:handshake',
  },
  {
    step: 2,
    title: 'Set Up Your Store',
    description: 'Create your digital storefront with product catalogs and pricing.',
    icon: 'mdi:store',
  },
  {
    step: 3,
    title: 'Receive Orders',
    description: 'Get real-time notifications and manage incoming orders efficiently.',
    icon: 'mdi:bell-ring',
  },
  {
    step: 4,
    title: 'Fulfill & Grow',
    description: 'Process orders, manage inventory, and grow your business with our tools.',
    icon: 'mdi:trending-up',
  },
];

// Content for different user types
export const userTypeContent = {
  restaurant: {
    features: [
      {
        icon: 'mdi:lightning-bolt',
        title: 'Get your order in minutes!',
        description:
          'Our streamlined platform ensures quick onboarding and fast order processing for restaurants.',
      },
      {
        icon: 'mdi:refresh',
        title: 'Real-time updates!',
        description:
          'Live inventory tracking, real-time pricing, and instant order notifications keep you informed.',
      },
      {
        icon: 'mdi:shopping-basket',
        title: 'Shop from thousands of items!',
        description:
          'From fresh produce to kitchen supplies, connect with a vast network of verified suppliers.',
      },
    ],
    screenshots: [
      '/assets/images/restaurant-dashboard.png',
      '/assets/images/restaurant-catalog.png',
      '/assets/images/restaurant-orders.png',
    ],
  },
  supplier: {
    features: [
      {
        icon: 'mdi:lightning-bolt',
        title: 'List your products instantly!',
        description:
          'Quick onboarding process to get your products listed on our platform in minutes.',
      },
      {
        icon: 'mdi:refresh',
        title: 'Live inventory sync!',
        description:
          'Automated inventory updates and real-time order notifications for efficient fulfillment.',
      },
      {
        icon: 'mdi:shopping-basket',
        title: 'Reach thousands of restaurants!',
        description: 'Expand your customer base by connecting with restaurants across the region.',
      },
    ],
    screenshots: [
      '/assets/images/supplier-dashboard.png',
      '/assets/images/supplier-products.png',
      '/assets/images/supplier-orders.png',
    ],
  },
};
